import { render, staticRenderFns } from "./SoldByCard.vue?vue&type=template&id=483c9bd2"
import script from "./SoldByCard.vue?vue&type=script&lang=ts"
export * from "./SoldByCard.vue?vue&type=script&lang=ts"
import style0 from "./SoldByCard.vue?vue&type=style&index=0&id=483c9bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports